// components/OnlaynTalimResurslari.jsx
import React from "react";
import YouTube from "react-youtube";

const OnlaynTalimResurslari = () => {
    const videolar = [
        {
            id: 1,
            link: "https://www.youtube.com/watch?v=MSl2ULwZ5rQ",
        },
        {
            id: 2,
            link: "https://www.youtube.com/watch?v=zY1RU6bFvYc",
        },
        {
            id: 3,
            link: "https://www.youtube.com/watch?v=N4GCxh3hg_o",
        },
        {
            id: 4,
            link: "https://www.youtube.com/watch?v=0jACOwxV8NM",
        },
        {
            id: 5,
            link: "https://www.youtube.com/watch?v=WcCJ0ZfQtCc&t=5s",
        },
    ];
    const opts = {
        height: "100%",
        width: "100%",
        playerVars: {
            autoplay: 0,
        },
    };

    const onReady = (event) => {
        // event.target.pauseVideo(); // istasangiz avtomatik pauselash
    };

    return (
        <div className="max-w-7xl mx-auto px-4 py-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {videolar?.map((item, idx) => {
                    const videoId = item.link.includes("youtube")
                        ? item.link.split("v=")[1]?.split("&")[0] ||
                          item.link.split("/").pop()
                        : null;

                    return (
                        <div
                            key={idx}
                            className="relative aspect-video rounded-xl overflow-hidden shadow-md"
                        >
                            {videoId ? (
                                <YouTube
                                    className="absolute top-0 left-0 w-full h-full"
                                    videoId={videoId}
                                    opts={opts}
                                    onReady={onReady}
                                />
                            ) : (
                                <div className="flex items-center justify-center w-full h-full bg-gray-200 text-gray-600 text-center text-sm p-4">
                                    YouTube link emas: {item.link}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default OnlaynTalimResurslari;
